import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import Logo from './logo.jpg'; // Update the path to your logo
import ShopBoxIcon from './SvgIcon'; // Update the path to your ShopBoxIcon component

const Header = ({
  isOpen,
  toggleMenu,
  calculateTotalQuantity,
  numbe,
  successMessage,
  handleTypeChange,
  itemCount,
}) => {
  return (
    <nav>
      <div className="fixed top-0 z-50 md:sticky w-screen sm:w-auto">
        <div className="overflow-auto text-white bg-[#1A2A3A] flex flex-row justify-between items-center space-x-6 p-4">
          <img src={Logo} alt="My Logo" className="object-cover h-20 w-20" />
          <h1 className="lg:text-2xl text-xl flex items-center">
            <Link to="/">Cotton Kosovo Socks</Link>
          </h1>
          {successMessage && (
            <div className="fixed top-28 md:top-4 right-4 bg-green-500 text-white px-4 py-2 rounded z-50">
              Item added successfully!
            </div>
          )}
          <div className="relative">
            {/* Hamburger Menu Button */}
            <button
              onClick={toggleMenu}
              className="text-[#212529] focus:outline-none lg:hidden relative"
            >
              {/* Hamburger Icon */}
              <div className="w-6 h-0.5 bg-white mb-1 transition-transform duration-300 ease-in-out"></div>
              <div className="w-6 h-0.5 bg-white mb-1 transition-transform duration-300 ease-in-out"></div>
              <div className="w-6 h-0.5 bg-white transition-transform duration-300 ease-in-out"></div>

              {/* Cart Quantity Indicator */}
              {calculateTotalQuantity() > 0 && (
                <div className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full animate-bounce"></div>
              )}
            </button>

            {/* Backdrop */}
            {isOpen && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                onClick={toggleMenu}
              ></div>
            )}

            {/* Mobile Menu */}
            <div
              className={`${
                isOpen ? 'translate-x-0' : 'translate-x-full'
              } fixed z-50 top-[110px] right-0 w-full h-screen bg-gradient-to-br from-gray-700 via-gray-800 to-black shadow-lg transform transition-transform duration-300 ease-in-out lg:hidden`}
            >
              {/* Close Button */}
              <button
                onClick={toggleMenu}
                className="text-white p-4 focus:outline-none absolute top-2 right-2 hover:bg-gray-700 rounded-full transition-colors duration-300"
              >
                ✕
              </button>

              {/* Menu Items */}
              <nav className="flex flex-col items-start p-6 space-y-6 mt-10">
                {/* About Us Link */}
                <ul className="w-full">
                  <li className="hover:text-white text-left transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 hover:bg-indigo-500 duration-300 rounded-lg">
                    <Link
                      to="/about"
                      onClick={toggleMenu}
                      className="block py-3 px-4 text-lg font-medium"
                    >
                      About Us
                    </Link>
                  </li>
                </ul>

                {/* Contact Us Link */}
                <ul className="w-full">
                  <li className="hover:text-white text-left transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 hover:bg-indigo-500 duration-300 rounded-lg">
                    <a
                      href="#contact"
                      onClick={toggleMenu}
                      className="block py-3 px-4 text-lg font-medium"
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>

                {/* All Products Link */}
                <ul className="w-full">
                  <li className="hover:text-white text-left transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 hover:bg-indigo-500 duration-300 rounded-lg">
                    <Link
                      to="/products"
                      onClick={toggleMenu}
                      className="block py-3 px-4 text-lg font-medium"
                    >
                      <button onClick={()=> handleTypeChange('')}>All Products</button>
                    </Link>
                  </li>
                </ul>

                {/* Cart Icon */}
                <button
                  onClick={toggleMenu}
                  className="flex items-center justify-start w-full py-3 px-4 hover:bg-indigo-500 rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300"
                >
                  <ShopBoxIcon itemCount={itemCount} numbe={numbe} />
                </button>
              </nav>

              {/* Social Media Links */}
              <div className="flex justify-center mt-80 space-x-4 ml-3">
                <a
                  href="https://www.instagram.com/cotton.socks.ks/?hl=en"
                  className="text-[#c13584] hover:text-[#e1306c] transition duration-300"
                >
                  <FaInstagram className="h-10 w-10" />
                </a>
                <a
                  href="https://www.facebook.com/Cotton.socks.ks"
                  className="text-[#3b5998] hover:text-[#1877f2] transition duration-300"
                >
                  <FaFacebookF className="h-10 w-10" />
                </a>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <header id="header" className="p-[20px] mx-11 hidden lg:flex">
            <nav id="navbar" className="flex flex-row justify-center items-center space-x-5">
              <ul>
                <li className="hover:text-white text-center transition ease-in-out delay-150 w-20 rounded-2xl hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300">
                  <Link to="/about">About us</Link>
                </li>
              </ul>
              <ul>
                <li className="hover:text-white text-center transition ease-in-out delay-150 w-32 rounded-2xl hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300">
                  <a href="#contact">Contact us</a>
                </li>
              </ul>
              <ShopBoxIcon itemCount={calculateTotalQuantity()} numbe={numbe} />
            </nav>
          </header>
        </div>
      </div>
    </nav>
  );
};

export default Header;